import * as React from "react";
const SvgHome = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m12 5.69 5 4.5V18h-2v-6H9v6H7v-7.81zM12 3 2 12h3v8h6v-6h2v6h6v-8h3z", fill: "currentColor" }));
export default SvgHome;
